import React from "react";
import { useLanguage } from "../context/LanguageContext";

const BrazilFlag = ({ className = "w-6 h-4" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 720 504"
    className={`${className} rounded-sm overflow-hidden`}
    role="img"
    aria-label="Bandeira do Brasil"
  >
    <rect width="720" height="504" fill="#009c3b" />
    <polygon points="360,54 666,252 360,450 54,252" fill="#ffdf00" />
    <circle cx="360" cy="252" r="126" fill="#002776" />
    <path
      d="M234,252 a126,126 0 0,0 252,0 a122,122 0 0,1 -252,0"
      fill="#ffffff"
    />
  </svg>
);

const UsaFlag = ({ className = "w-6 h-4" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 741 390"
    className={`${className} rounded-sm overflow-hidden`}
    role="img"
    aria-label="United States Flag"
  >
    <rect width="741" height="390" fill="#b22234" />
    <path
      d="M0,30h741M0,90h741M0,150h741M0,210h741M0,270h741M0,330h741"
      stroke="#fff"
      strokeWidth="30"
    />
    <rect width="296" height="210" fill="#3c3b6e" />
    <g fill="#fff">
      {/* Visual representation of 50-star canton */}
      <circle cx="30" cy="21" r="7" />
      <circle cx="89" cy="21" r="7" />
      <circle cx="148" cy="21" r="7" />
      <circle cx="207" cy="21" r="7" />
      <circle cx="266" cy="21" r="7" />
      <circle cx="60" cy="42" r="7" />
      <circle cx="119" cy="42" r="7" />
      <circle cx="178" cy="42" r="7" />
      <circle cx="237" cy="42" r="7" />
      <circle cx="30" cy="63" r="7" />
      <circle cx="89" cy="63" r="7" />
      <circle cx="148" cy="63" r="7" />
      <circle cx="207" cy="63" r="7" />
      <circle cx="266" cy="63" r="7" />
      <circle cx="60" cy="84" r="7" />
      <circle cx="119" cy="84" r="7" />
      <circle cx="178" cy="84" r="7" />
      <circle cx="237" cy="84" r="7" />
      <circle cx="30" cy="105" r="7" />
      <circle cx="89" cy="105" r="7" />
      <circle cx="148" cy="105" r="7" />
      <circle cx="207" cy="105" r="7" />
      <circle cx="266" cy="105" r="7" />
      <circle cx="60" cy="126" r="7" />
      <circle cx="119" cy="126" r="7" />
      <circle cx="178" cy="126" r="7" />
      <circle cx="237" cy="126" r="7" />
      <circle cx="30" cy="147" r="7" />
      <circle cx="89" cy="147" r="7" />
      <circle cx="148" cy="147" r="7" />
      <circle cx="207" cy="147" r="7" />
      <circle cx="266" cy="147" r="7" />
      <circle cx="60" cy="168" r="7" />
      <circle cx="119" cy="168" r="7" />
      <circle cx="178" cy="168" r="7" />
      <circle cx="237" cy="168" r="7" />
      <circle cx="30" cy="189" r="7" />
      <circle cx="89" cy="189" r="7" />
      <circle cx="148" cy="189" r="7" />
      <circle cx="207" cy="189" r="7" />
      <circle cx="266" cy="189" r="7" />
    </g>
  </svg>
);

const LanguageSwitcher = ({ className = "" }) => {
  const { language, setLanguage } = useLanguage();

  return (
    <div
      className={`inline-flex items-center gap-1.5 p-1 bg-base-300/60 hover:bg-base-300 rounded-full border border-base-content/10 shadow-sm transition-all ${className}`}
    >
      <button
        type="button"
        onClick={() => setLanguage("pt")}
        title="Português"
        aria-label="Mudar para Português"
        className={`flex items-center justify-center p-1 rounded-full transition-all duration-200 ${
          language === "pt"
            ? "ring-2 ring-blue-500 shadow-md scale-110 bg-base-100 opacity-100"
            : "opacity-50 hover:opacity-100 grayscale hover:grayscale-0 hover:scale-105"
        }`}
      >
        <BrazilFlag className="w-5 h-3.5 sm:w-6 sm:h-4 shadow-xs" />
      </button>

      <button
        type="button"
        onClick={() => setLanguage("en")}
        title="English"
        aria-label="Switch to English"
        className={`flex items-center justify-center p-1 rounded-full transition-all duration-200 ${
          language === "en"
            ? "ring-2 ring-blue-500 shadow-md scale-110 bg-base-100 opacity-100"
            : "opacity-50 hover:opacity-100 grayscale hover:grayscale-0 hover:scale-105"
        }`}
      >
        <UsaFlag className="w-5 h-3.5 sm:w-6 sm:h-4 shadow-xs" />
      </button>
    </div>
  );
};

export default LanguageSwitcher;
